import { Component, OnInit } from '@angular/core';
import { PaymentActions } from '@app/core/actions';
import * as fromRoot from '@app/reducers';
import { DialogRef } from '@ngneat/dialog';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { first } from 'rxjs/operators';
import * as fromSignup from '../../../reducers';
import { InvalidVatNumberError } from '@smash-sdk/billing/ejs/01-2024/types/UpdateInformations/UpdateInformationsError';

@Component({
  selector: 'app-modal-signup-process',
  templateUrl: './modal-signup-process.component.html',
  styleUrls: ['./modal-signup-process.component.scss']
})
export class ModalSignupProcessComponent implements OnInit {

  signupProcessing$: Observable<boolean>;
  signupSucceed$: Observable<boolean>;
  signupFailed$: Observable<boolean>;
  signupError$: Observable<any>;

  updateAccountProcessing$: Observable<boolean>;
  updateAccountSucceed$: Observable<boolean>;
  updateAccountFailed$: Observable<boolean>;
  updateAccountError$: Observable<boolean>;

  updateBillingInformationsProcessing$: Observable<boolean>;
  updateBillingInformationsFailed$: Observable<boolean>;
  updateBillingInformationsError$: Observable<boolean>;

  updateSubscriptionProcessing$: Observable<boolean>;
  updateSubscriptionFailed$: Observable<boolean>;

  paymentProcessing$: Observable<boolean>;
  paymentFailed$: Observable<boolean>;

  constructor(
    private store$: Store<fromRoot.State & fromSignup.State>,
    private ref: DialogRef
  ) {
    this.signupProcessing$ = this.store$.pipe(select(fromSignup.getSignupProcessing));
    this.signupSucceed$ = this.store$.pipe(select(fromSignup.getSignupSucceed));

    this.signupSucceed$.pipe(first(suceed => !!suceed)).subscribe(() => this.closeModal());

    this.signupFailed$ = this.store$.pipe(select(fromSignup.getSignupFailed));
    this.signupError$ = this.store$.pipe(select(fromSignup.getSignupError));

    this.paymentProcessing$ = this.store$.pipe(select(fromRoot.getPaymentProcessing));
    this.paymentFailed$ = this.store$.pipe(select(fromRoot.getPaymentFailed));

    this.updateAccountProcessing$ = this.store$.pipe(select(fromSignup.getUpdateAccountProcessing));
    this.updateAccountSucceed$ = this.store$.pipe(select(fromSignup.getUpdateAccountSucceed));
    this.updateAccountFailed$ = this.store$.pipe(select(fromSignup.getUpdateAccountFailed));

    this.updateBillingInformationsProcessing$ = this.store$.pipe(select(fromSignup.getUpdateBillingInformationsProcessing));
    this.updateBillingInformationsFailed$ = this.store$.pipe(select(fromSignup.getUpdateBillingInformationsFailed));
    this.updateBillingInformationsError$ = this.store$.pipe(select(fromSignup.getUpdateBillingInformationsError));

    this.updateSubscriptionProcessing$ = this.store$.pipe(select(fromSignup.getUpdateSubscriptionProcessing));
    this.updateSubscriptionFailed$ = this.store$.pipe(select(fromSignup.getUpdateSubscriptionFailed));
  }

  ngOnInit(): void {
  }

  retrySignup() {
    this.store$.dispatch(PaymentActions.resetSignupProcess());
    this.closeModal();
  }

  closeModal() {
    this.ref.close();
  }

  isInvalidVatNumberError(error: any) {
    return error instanceof InvalidVatNumberError;
  }

}
